import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import VoiceCallAgentIntegrations from '../../VoiceCallAgentIntegrations/components/VoiceCallAgentIntegrations';
import PosIntegration from '../components/Pos/PosIntegration';
import useUser from '../../../hooks/useUser';
import Permissions from '../../../shared/enums/Permissions';

const Integrations = lazy(() => import('../components/Integrations'));

const SocialMediaIntegration = lazy(
  () => import('../../SocialMediaIntegration/components/SocialMediaIntegration')
);
const NotificationConfigurations = lazy(
  () => import('../../NotificationConfigurations/components/NotificationConfigurations')
);
const NotificationConfigOld = lazy(
  () => import('../../Channels/components/Channels')
);

const VoiceCallIntegrations = lazy(
  () => import('../../VoiceCallIntegrations/components/VoiceCallIntegrations')
);

const PaymentGatewayIntegrations = lazy(
  () => import('../../PaymentGatewayIntegrations/components/PaymentGatewayIntegrations')
);

const FakeProviderLogsPage = lazy(
  () => import('../../FakeProviderLogs/components/FakeProviderLogsPage')
);

const EmailValidationCreditsPage = lazy(
  () => import('../../EmailValidation/components/EmailValidationCreditsPage')
);

// The tab is hidden without the permission; a typed URL lands back on the first tab.
const EmailValidationCreditsRoute = () => {
  const { userPermissions } = useUser();
  if (!userPermissions.includes(Permissions.EMAIL_VALIDATION_VIEW))
    return <Navigate to='../channel' replace />;
  return <EmailValidationCreditsPage />;
};

const integrationRoute: RouteObject = {
  path: '/settings/integrations',
  element: <Integrations />,
  children: [
    {
      index: true,
      element: <Navigate to='./channel' replace />,
    },
    {
      path: 'channel',
      element: <NotificationConfigurations />,
    },
    {
      path: 'channel-old',
      element: <NotificationConfigOld />,
    },
    {
      path: 'voice-call',
      element: <VoiceCallIntegrations />,
    },
    {
      path: 'voice-call-agent',
      element: <VoiceCallAgentIntegrations />,
    },
    {
      path: 'social-media',
      element: <SocialMediaIntegration />,
    },
    {
      path: 'pos',
      element: <PosIntegration />,
    },
    {
      path: 'payments',
      element: <PaymentGatewayIntegrations />,
    },
    {
      path: 'email-validation',
      element: <EmailValidationCreditsRoute />,
    },
    {
      path: 'test-logs',
      element: <FakeProviderLogsPage embedded />,
    },
  ],
};

export default integrationRoute;
